module.exports = __webpack_public_path__ + "img/6.35bbd12f.jpg";